<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <WizardHeader :title="$t('account_settings_legal.acknowledgements')" :icon="UsersIcon"></WizardHeader>
            <div class="px-4 py-3 sm:px-6">
                <LegalAcknowledgementsTwoForm v-model="formValues"></LegalAcknowledgementsTwoForm>
            </div>
        </template>
        <template #nextButton>
            <BaseButtonPrimary
                :loading="usePersonalAccountDataState().saving"
                :disabled="usePersonalAccountDataState().saving || formState.hasValidationErrors"
                size="lg"
                @click="submit()"
                >{{ $t('widget.save') }}
            </BaseButtonPrimary>
        </template>
        <template #previousButton>
            <BaseButtonMuted size="lg" @click="navigateToPreviousTab()">{{ $t('widget.back') }}</BaseButtonMuted>
        </template>

        <template #sidebar>
            <p class="pb-2 pb-2 text-base text-gray-800">
                {{ $t('esac_widget_sidebar.legal_acknowledgements') }}
            </p>
        </template>
    </WizardTabWithSidebar>
</template>

<script setup lang="ts">
import WizardTabWithSidebar from '../../WizardTabWithSidebar.vue'
import WizardHeader from '../../WizardHeader.vue'
import BaseButtonPrimary from '../../../base/BaseButtonPrimary.vue'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { useLegalAccountFormState } from '../../../../utilities/account/useAccountFormLegal'
import { inject, onMounted, ref } from 'vue'
import { UsersIcon } from '@heroicons/vue/outline'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import LegalAcknowledgementsTwoForm from './form/LegalAcknowledgementsTwoForm.vue'
import { LegalAcknowledgmentsTwo } from './form/forms'

const formState = useLegalAccountFormState()
const { navigateToNextTab, navigateToPreviousTab, navigateToTab } = inject('navigation')

const formValues = ref(new LegalAcknowledgmentsTwo())

onMounted(() => {
    if (useLegalAccountDataState().legalProfile.compliance_profiles.esac) {
        formValues.value = useLegalAccountDataState().legalProfile.compliance_profiles.esac.acknowledgements
    }
})

async function submit() {
    const { valid } = await formState.currentForm.validate()
    if (valid) {
        let acknowledgements = Object.assign(
            useLegalAccountDataState().legalProfile.compliance_profiles.esac.acknowledgements,
            formValues.value
        )
        useLegalAccountDataState().legalProfile.compliance_profiles.esac.acknowledgements = acknowledgements
        await formState.submit()
        navigateToNextTab()
    }
}
</script>

<style scoped></style>
